import { isString } from "lodash";
// biome-ignore lint/suspicious/noExplicitAny: Function needs to operate on arbitrary errors at network boundary
export const isAuthFailure = (error) => {
    if (!error)
        return false;
    if (error.code === 401)
        return true;
    const code = error?.data?.code;
    if (!isString(code))
        return false;
    if (code === "AUTH_FAILURE")
        return true;
    if (code.match(/^FST_JWT_/))
        return true;
    return false;
};
//# sourceMappingURL=auth.js.map